import styled from 'styled-components'

export const Container = styled.div`
  display: inline;
  margin-right: 1em;
`
